<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    theme?: string
    isHero?: boolean
    isError?: boolean
    isFooter?: boolean
  }>(),
  {
    theme: 'green-light-green',
    isHero: false,
    isError: false,
    isFooter: false,
  },
)

const {
  setCurrentTheme,
  setBodyHeroTheme,
  resetBodyHeroTheme,
  setBodyFooterTheme,
  resetBodyFooterTheme,
  setBodyErrorTheme,
  resetBodyErrorTheme,
} = useTheme()
const element = useTemplateRef<HTMLDivElement>('element')

const targetIsVisible = shallowRef(false)

useIntersectionObserver(
  element,
  ([entry]) => {
    targetIsVisible.value = entry?.isIntersecting || false

    if (targetIsVisible.value) {
      // console.log('theme', props.theme, targetIsVisible.value, entry)
      setCurrentTheme(props.theme || 'green-light-green')

      // Set body background to red if this is the hero section
      if (props.isHero) {
        setBodyHeroTheme(props.theme || 'green-light-green')
        // document.body.style.backgroundColor = 'red'
      }

      if (props.isFooter) {
        setBodyFooterTheme()
      }
      if (props.isError) {
        setBodyErrorTheme()
      }
    } else if (props.isHero) {
      // Reset background when hero is not visible
      resetBodyHeroTheme(props.theme || 'green-light-green')
      // document.body.style.backgroundColor = ''
    } else if (props.isError) {
      resetBodyErrorTheme()
    } else if (props.isFooter) {
      resetBodyFooterTheme()
    }
  },
  {
    rootMargin: `0px 0px ${props.isFooter ? '0px' : '-100%'} 0px`,
  },
)
</script>

<template>
  <div ref="element" class="pointer-events-none absolute inset-0 h-full w-full" />
</template>
